var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g3, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g4, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g5, _path52, _g6, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgActivation = function SvgActivation(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 62,
    viewBox: "0 0 74 62",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.8409 0.831144L33.9283 46.6465L67.0874 51.6495L74 5.83414L40.8409 0.831144Z",
    fill: "url(#paint0_linear_11398_14080)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2128 1.23154L34.453 46.0347L66.7681 50.9103L73.528 6.10721L41.2128 1.23154Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.907 24.8305L42.5839 21.3115L42.3705 22.7254L65.6937 26.2443L65.907 24.8305Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3743 28.3632L42.0511 24.8442L41.8378 26.2581L65.161 29.777L65.3743 28.3632Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6135 13.5214L55.5979 11.7085L55.3846 13.1223L67.4002 14.9352L67.6135 13.5214Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0211 16.8958L56.1259 15.4028L55.9125 16.8167L65.8078 18.3097L66.0211 16.8958Z",
    fill: "#00BFA6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0144 31.471L41.5173 28.3784L41.304 29.7923L61.8011 32.8848L62.0144 31.471Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6531 34.578L40.9838 31.9121L40.7704 33.326L58.4398 35.9919L58.6531 34.578Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0001 37.7923L40.451 35.4463L40.2377 36.8601L55.7867 39.2061L56.0001 37.7923Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7072 41.9658L39.9175 38.98L39.7042 40.3938L59.4939 43.3797L59.7072 41.9658Z",
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1596 43.6866L39.3855 42.5137L39.1722 43.9275L46.9463 45.1005L47.1596 43.6866Z",
    fill: "#00BFA6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.3212 13.6531C53.4431 12.8392 53.3525 12.0076 53.0579 11.2391C52.7633 10.4707 52.2749 9.79157 51.6401 9.2678C51.0054 8.74402 50.2458 8.39343 49.4354 8.25012C48.625 8.1068 47.7913 8.17563 47.0154 8.44994C46.2395 8.72424 45.5478 9.19468 45.0075 9.81548C44.4673 10.4363 44.0969 11.1863 43.9323 11.9927C43.7678 12.799 43.8147 13.6342 44.0686 14.4171C44.3224 15.1999 44.7746 15.9038 45.381 16.4601V16.4815C45.5125 16.6533 45.6768 16.7972 45.8644 16.9049L45.8735 16.8844C46.5048 17.341 47.2447 17.6244 48.0195 17.7066H48.0433C48.7548 17.8305 49.486 17.776 50.1712 17.5479C50.1712 17.5479 50.1786 17.5364 50.1918 17.5142C50.368 17.4622 50.5346 17.3819 50.6851 17.2766L50.6999 17.224C51.3931 16.8852 51.9937 16.3833 52.4503 15.7613C52.9069 15.1394 53.2057 14.4159 53.3212 13.6531V13.6531Z",
    fill: "url(#paint1_linear_11398_14080)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1573 13.4579C53.5386 10.9308 51.7991 8.57313 49.272 8.19185C46.7449 7.81056 44.3872 9.55007 44.0059 12.0772C43.6246 14.6042 45.3642 16.9619 47.8912 17.3432C50.4183 17.7245 52.776 15.985 53.1573 13.4579Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.473 14.2919C46.473 14.2919 45.3728 14.2162 45.358 16.2463C45.4855 16.413 45.6448 16.5528 45.8267 16.6574L46.7525 14.6742L46.473 14.2919Z",
    fill: "#FDA57D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0102 14.8262C50.0102 14.8262 51.0873 15.0802 50.5035 17.0231C50.3325 17.1447 50.1392 17.231 49.9346 17.2772L49.6344 15.109L50.0102 14.8262Z",
    fill: "#FDA57D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0107 11.0449C47.0107 11.0449 46.2642 12.4764 46.0027 12.2914C46.0027 12.2914 48.3781 15.0623 51.1449 13.0668C50.9296 12.5276 50.6505 12.0161 50.3136 11.5432L47.0107 11.0449Z",
    fill: "#333333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8163 11.4742C50.9853 10.3539 50.2141 9.30874 49.0938 9.13971C47.9735 8.97068 46.9283 9.74184 46.7593 10.8621C46.5903 11.9824 47.3614 13.0277 48.4817 13.1967C49.602 13.3657 50.6472 12.5946 50.8163 11.4742Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.9895 14.8242L46.4539 14.2905L45.9104 15.6562C45.9104 15.6562 45.6177 16.282 45.8159 16.6067C46.4107 17.0268 47.0932 17.3061 47.8119 17.4235C48.5305 17.5408 49.2665 17.4932 49.964 17.2842C50.1654 16.9286 50.2445 16.5167 50.1893 16.1118C50.1005 15.4227 50.1498 16.0575 50.1498 16.0575L49.9895 14.8242Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.0372 14.8305L46.5017 14.2969L45.959 15.6618C45.959 15.6618 45.6663 16.2875 45.8645 16.6122C46.4593 17.0323 47.1418 17.3116 47.8605 17.429C48.5791 17.5464 49.315 17.4987 50.0126 17.2898C50.214 16.9341 50.2932 16.5222 50.2379 16.1173C50.1491 15.4283 50.1984 16.063 50.1984 16.063L50.0372 14.8305Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.011 14.8266L46.4754 14.293L45.9319 15.6587C45.9319 15.6587 45.6392 16.2844 45.8374 16.6092C46.4322 17.0292 47.1147 17.3085 47.8334 17.4259C48.552 17.5433 49.2879 17.4957 49.9855 17.2867C50.1869 16.931 50.266 16.5191 50.2108 16.1142C50.122 15.4252 50.1713 16.0599 50.1713 16.0599L50.011 14.8266Z",
    fill: "#FDD835"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.7334 13.2856L49.1497 13.4993L48.957 14.7766C48.9344 14.926 48.8534 15.0604 48.7318 15.1501C48.6102 15.2398 48.458 15.2775 48.3085 15.255L48.0191 15.2113C47.8697 15.1888 47.7353 15.1078 47.6456 14.9862C47.5559 14.8646 47.5181 14.7123 47.5407 14.5629L47.7334 13.2856Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7408 13.2339L49.1563 13.4475L48.9636 14.7247C48.9411 14.8741 48.8601 15.0085 48.7385 15.0982C48.6169 15.1879 48.4646 15.2257 48.3152 15.2031L48.0265 15.1596C47.8771 15.137 47.7428 15.056 47.653 14.9344C47.5633 14.8128 47.5256 14.6606 47.5481 14.5111L47.7408 13.2339Z",
    fill: "#FDA57D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.7145 13.4337C48.1447 13.673 48.6464 13.7503 49.1287 13.6516L49.155 13.4781L47.74 13.2651L47.7145 13.4337Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7496 11.9147C50.9187 10.7944 50.1475 9.74917 49.0272 9.58014C47.9069 9.41111 46.8617 10.1823 46.6927 11.3026C46.5236 12.4229 47.2948 13.4681 48.4151 13.6371C49.5354 13.8061 50.5806 13.035 50.7496 11.9147Z",
    fill: "#FDA57D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8931 10.5443L50.7575 11.1273C50.7403 10.6999 50.5734 10.2923 50.286 9.97558C49.9987 9.65888 49.609 9.45332 49.1854 9.39483C48.7372 9.37632 48.2916 9.4721 47.8906 9.67318C47.4896 9.87426 47.1463 10.174 46.8931 10.5443Z",
    fill: "#333333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9357 11.2506C46.9652 11.0553 46.9046 10.8842 46.8005 10.8685C46.6963 10.8528 46.588 10.9984 46.5585 11.1937C46.529 11.389 46.5896 11.5601 46.6937 11.5758C46.7979 11.5915 46.9063 11.4459 46.9357 11.2506Z",
    fill: "#FDA57D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8986 11.8492C50.9281 11.6539 50.8675 11.4828 50.7634 11.4671C50.6592 11.4514 50.5508 11.597 50.5214 11.7923C50.4919 11.9877 50.5525 12.1587 50.6566 12.1745C50.7608 12.1902 50.8691 12.0446 50.8986 11.8492Z",
    fill: "#FDA57D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.8873 10.597L50.7518 11.18C50.7346 10.7527 50.5677 10.345 50.2803 10.0283C49.9929 9.71163 49.6033 9.50605 49.1797 9.44757C48.7315 9.42905 48.2859 9.52483 47.8849 9.72591C47.4839 9.927 47.1406 10.2268 46.8873 10.597V10.597Z",
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.1927 7.39854L0.00012207 12.7793L7.43472 58.6415L40.6273 53.2607L33.1927 7.39854Z",
    fill: "url(#paint2_linear_11398_14080)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7003 7.68128L0.449951 12.9683L7.78006 57.6816L40.0304 52.3946L32.7003 7.68128Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2052 27.8351L7.92883 31.6509L8.16015 33.0619L31.4365 29.2461L31.2052 27.8351Z",
    fill: "#E0E0E0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7832 31.3624L8.50684 35.1782L8.73815 36.5892L32.0145 32.7734L31.7832 31.3624Z",
    fill: "#E0E0E0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3561 16.5488L17.3645 18.5146L17.5958 19.9257L29.5874 17.9598L29.3561 16.5488Z",
    fill: "#E0E0E0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8762 20.2497L19.0007 21.8687L19.232 23.2797L29.1075 21.6607L28.8762 20.2497Z",
    fill: "#00BFA6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.541 35.3511L9.08496 38.7046L9.31628 40.1156L29.7723 36.7621L29.541 35.3511Z",
    fill: "#E0E0E0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2968 39.3401L9.66284 42.231L9.89416 43.642L27.5281 40.7511L27.2968 39.3401Z",
    fill: "#E0E0E0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7588 43.2144L10.241 45.7583L10.4723 47.1693L25.9901 44.6254L25.7588 43.2144Z",
    fill: "#E0E0E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5698 46.0464L10.8197 49.2842L11.051 50.6952L30.8011 47.4574L30.5698 46.0464Z",
    fill: "#E0E0E0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1572 51.5396L11.3987 52.8115L11.63 54.2225L19.3885 52.9506L19.1572 51.5396Z",
    fill: "#00BFA6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.2284 20.7595C16.0913 19.9239 15.7403 19.1381 15.2095 18.4785C14.6786 17.8189 13.986 17.3079 13.1991 16.9954C12.4123 16.6828 11.5578 16.5793 10.7191 16.6948C9.88029 16.8104 9.08573 17.1412 8.4127 17.6549C7.73967 18.1686 7.21109 18.8479 6.87842 19.6265C6.54576 20.4051 6.42033 21.2566 6.51434 22.098C6.60834 22.9395 6.91859 23.7423 7.41488 24.4283C7.91118 25.1143 8.57661 25.6601 9.34642 26.0127L9.353 26.034C9.53588 26.1596 9.74185 26.2476 9.95897 26.293V26.27C10.7207 26.5188 11.5343 26.5636 12.3188 26.3999H12.3426C13.0779 26.2967 13.776 26.0124 14.3743 25.5728C14.3752 25.5596 14.378 25.5466 14.3825 25.5341C14.5377 25.4275 14.6746 25.2964 14.7879 25.1461V25.0926C15.3618 24.5416 15.7928 23.8591 16.0438 23.1041C16.2948 22.3492 16.3581 21.5444 16.2284 20.7595Z",
    fill: "url(#paint3_linear_11398_14080)"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1599 26.2467C14.7527 25.8217 16.51 23.3752 16.085 20.7824C15.6599 18.1896 13.2134 16.4323 10.6206 16.8573C8.0278 17.2824 6.27048 19.7288 6.69553 22.3217C7.12059 24.9145 9.56706 26.6718 12.1599 26.2467Z",
    fill: "#F5F5F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65786 23.7222C9.65786 23.7222 8.55773 23.9976 9.18344 25.9866C9.36091 26.1094 9.56102 26.1958 9.77216 26.2406L10.0525 24.0075L9.65786 23.7222Z",
    fill: "#4D8AF0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2879 23.1271C13.2879 23.1271 14.4218 23.035 14.4596 25.1226C14.3301 25.2938 14.168 25.4377 13.9827 25.546L13.0043 23.5193L13.2879 23.1271Z",
    fill: "#4D8AF0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2746 22.0156C12.424 21.8272 13.203 20.7426 13.0146 19.5932C12.8262 18.4438 11.7416 17.6647 10.5922 17.8532C9.44278 18.0416 8.66374 19.1261 8.85217 20.2756C9.0406 21.425 10.1252 22.204 11.2746 22.0156Z",
    fill: "#333333"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2667 23.1299L9.63662 23.7227L9.5363 25.2299C9.5363 25.2299 9.45409 25.9353 9.74351 26.1894C10.4575 26.4124 11.2128 26.4698 11.9523 26.3571C12.6917 26.2444 13.3958 25.9646 14.0109 25.539C14.0956 25.1277 14.043 24.6999 13.8612 24.3213C13.5562 23.675 13.8045 24.281 13.8045 24.281L13.2667 23.1299Z",
    fill: "#4D8AF0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3143 23.1226L9.68424 23.7154L9.58392 25.2233C9.58392 25.2233 9.50168 25.9288 9.7911 26.1829C10.5051 26.4059 11.2604 26.4632 11.9999 26.3505C12.7393 26.2378 13.4433 25.958 14.0584 25.5325C14.1433 25.1209 14.0908 24.6928 13.9088 24.314C13.6038 23.6685 13.8521 24.2737 13.8521 24.2737L13.3143 23.1226Z",
    fill: "#4D8AF0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2872 23.127L9.65713 23.7198L9.55681 25.2302C9.55681 25.2302 9.4746 25.9356 9.76402 26.1897C10.478 26.4127 11.2334 26.47 11.9728 26.3573C12.7122 26.2446 13.4162 25.9649 14.0314 25.5393C14.1161 25.128 14.0635 24.7002 13.8817 24.3216C13.5767 23.6754 13.825 24.2813 13.825 24.2813L13.2872 23.127Z",
    fill: "#4D8AF0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.5748 22.334L12.0272 22.0959L12.2446 23.4217C12.269 23.5708 12.2332 23.7236 12.1451 23.8463C12.0569 23.969 11.9236 24.0517 11.7745 24.0762L11.4499 24.1294C11.3759 24.142 11.3001 24.1398 11.2269 24.123C11.1537 24.1061 11.0845 24.075 11.0234 24.0314C10.9623 23.9877 10.9104 23.9324 10.8707 23.8687C10.831 23.8049 10.8043 23.7339 10.7922 23.6598L10.5748 22.334Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5658 22.2798L12.0182 22.0417L12.2355 23.3675C12.26 23.5166 12.2242 23.6694 12.136 23.7921C12.0479 23.9148 11.9146 23.9975 11.7654 24.022L11.4409 24.0752C11.3668 24.0878 11.291 24.0856 11.2178 24.0688C11.1446 24.0519 11.0755 24.0208 11.0144 23.9772C10.9532 23.9335 10.9013 23.8782 10.8617 23.8145C10.822 23.7507 10.7953 23.6797 10.7831 23.6056L10.5658 22.2798Z",
    fill: "#FDA57D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.6018 22.4886C11.0984 22.587 11.6139 22.5042 12.0546 22.2551L12.025 22.0767L10.573 22.3151L10.6018 22.4886Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3484 22.4668C12.4979 22.2783 13.2769 21.1938 13.0885 20.0444C12.9 18.8949 11.8155 18.1159 10.6661 18.3043C9.51663 18.4928 8.73759 19.5773 8.92602 20.7267C9.11446 21.8762 10.199 22.6552 11.3484 22.4668Z",
    fill: "#FDA57D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.89478 19.9754L12.8636 19.325C12.7125 18.9119 12.4206 18.5653 12.0393 18.3461C11.6579 18.1268 11.2115 18.049 10.7785 18.1262C10.3338 18.2501 9.92776 18.4847 9.59834 18.8081C9.26891 19.1315 9.02685 19.5331 8.89478 19.9754Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88574 19.9216L12.8587 19.2704C12.7076 18.8573 12.4157 18.5106 12.0344 18.2914C11.653 18.0721 11.2066 17.9943 10.7736 18.0716C10.3284 18.1957 9.92186 18.4304 9.59179 18.7538C9.26171 19.0773 9.01884 19.479 8.88574 19.9216Z",
    fill: "#333333"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03938 21.1182C9.14696 21.1007 9.20772 20.9234 9.1751 20.7222C9.14247 20.5209 9.02881 20.3719 8.92123 20.3893C8.81365 20.4068 8.75289 20.5841 8.78552 20.7853C8.81814 20.9866 8.9318 21.1356 9.03938 21.1182Z",
    fill: "#FDA57D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M13.079 20.3275C13.1861 20.31 13.2462 20.133 13.2133 19.9322C13.1804 19.7315 13.0669 19.583 12.9598 19.6005C12.8527 19.6181 12.7925 19.7951 12.8255 19.9958C12.8584 20.1966 12.9719 20.3451 13.079 20.3275Z",
    fill: "#FDA57D"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.4307 14.8354H23.8964V61.1693H57.4307V14.8354Z",
    fill: "url(#paint4_linear_11398_14080)"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M57.004 15.1768H24.3231V60.487H57.004V15.1768Z",
    fill: "#FFFBF2"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.6884 25.544C28.688 24.6779 28.9119 23.8265 29.3383 23.0726C29.7648 22.3187 30.3792 21.6881 31.1217 21.2422C31.8642 20.7962 32.7096 20.5502 33.5754 20.528C34.4413 20.5058 35.2981 20.7082 36.0625 21.1155C36.8269 21.5228 37.4728 22.1211 37.9373 22.8522C38.4017 23.5832 38.669 24.4221 38.713 25.2871C38.757 26.1521 38.5762 27.0138 38.1883 27.7882C37.8004 28.5626 37.2186 29.2234 36.4995 29.7061V29.7283C36.3357 29.8857 36.1423 30.0089 35.9305 30.0909L35.9239 30.0687C35.1966 30.4454 34.3832 30.6248 33.565 30.5892H33.5403C32.7813 30.6059 32.03 30.4348 31.3532 30.0909C31.3532 30.0909 31.3474 30.0778 31.3384 30.0531C31.1641 29.9714 31.0042 29.862 30.8648 29.7292L30.8574 29.6724C30.1882 29.2117 29.6411 28.5952 29.2632 27.876C28.8853 27.1568 28.6881 26.3565 28.6884 25.544V25.544Z",
    fill: "url(#paint5_linear_11398_14080)"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7022 30.4082C36.3886 30.4082 38.5664 28.2304 38.5664 25.544C38.5664 22.8575 36.3886 20.6797 33.7022 20.6797C31.0157 20.6797 28.8379 22.8575 28.8379 25.544C28.8379 28.2304 31.0157 30.4082 33.7022 30.4082Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7937 27.3965C31.7937 27.3965 30.6352 27.4902 30.9411 29.6066C31.1 29.7589 31.2875 29.8783 31.4928 29.9577L32.1448 27.7509L31.7937 27.3965Z",
    fill: "#BE7C5E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5548 27.3965C35.5548 27.3965 36.7133 27.4902 36.4074 29.6066C36.2486 29.759 36.061 29.8783 35.8557 29.9577L35.2062 27.7443L35.5548 27.3965Z",
    fill: "#BE7C5E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8431 23.9349C31.8431 23.9349 31.7543 24.1947 31.6277 24.4957C31.3514 25.1534 31.6664 27.6768 32.3266 27.949C33.1873 28.332 34.1607 28.3769 35.0531 28.0748C35.9328 27.7541 36.2042 24.8813 35.5818 24.1808C35.5086 24.0985 35.4329 24.0163 35.3532 23.9341L31.8431 23.9349Z",
    fill: "#333333"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7048 25.9411C34.8955 25.9411 35.8607 24.9759 35.8607 23.7853C35.8607 22.5946 34.8955 21.6294 33.7048 21.6294C32.5142 21.6294 31.549 22.5946 31.549 23.7853C31.549 24.9759 32.5142 25.9411 33.7048 25.9411Z",
    fill: "#333333"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.5326 27.3965H31.7718L31.4207 28.9003C31.4207 28.9003 31.2143 29.5967 31.4708 29.9034C32.1541 30.2467 32.9068 30.4297 33.6714 30.4384C34.4361 30.4471 35.1927 30.2813 35.8837 29.9536C36.0372 29.5524 36.0548 29.1119 35.9338 28.6997C35.7332 27.9975 35.8837 28.6495 35.8837 28.6495L35.5326 27.3965Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.5818 27.3965H31.8193L31.4683 28.9003C31.4683 28.9003 31.2619 29.5967 31.5184 29.9034C32.2018 30.2467 32.9544 30.4297 33.7191 30.4384C34.4837 30.4471 35.2403 30.2813 35.9313 29.9536C36.0848 29.5524 36.1024 29.1119 35.9814 28.6997C35.7808 27.9975 35.9313 28.6495 35.9313 28.6495L35.5818 27.3965Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5547 27.3965H31.7938L31.4427 28.9003C31.4427 28.9003 31.2364 29.5967 31.4929 29.9034C32.1763 30.2467 32.9289 30.4296 33.6936 30.4383C34.4582 30.447 35.2148 30.2812 35.9058 29.9536C36.0594 29.5524 36.077 29.1119 35.9559 28.6997C35.7553 27.9975 35.9058 28.6495 35.9058 28.6495L35.5547 27.3965Z",
    fill: "#3AD29F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.9474 26.1475H34.4513V27.537C34.4513 27.6881 34.3913 27.8331 34.2844 27.94C34.1775 28.0468 34.0326 28.1068 33.8815 28.1068H33.5156C33.3645 28.1068 33.2195 28.0468 33.1127 27.94C33.0058 27.8331 32.9458 27.6881 32.9458 27.537V26.1475H32.9474Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9474 26.0918H34.4513V27.478C34.4513 27.6292 34.3913 27.7741 34.2844 27.881C34.1775 27.9878 34.0326 28.0479 33.8815 28.0479H33.5156C33.3645 28.0479 33.2195 27.9878 33.1127 27.881C33.0058 27.7741 32.9458 27.6292 32.9458 27.478V26.0918H32.9474Z",
    fill: "#BE7C5E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.9498 26.3048C33.435 26.4845 33.9685 26.4845 34.4537 26.3048V26.1206H32.9498V26.3048Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7048 26.4089C34.8955 26.4089 35.8607 25.4437 35.8607 24.253C35.8607 23.0624 34.8955 22.0972 33.7048 22.0972C32.5142 22.0972 31.549 23.0624 31.549 24.253C31.549 25.4437 32.5142 26.4089 33.7048 26.4089Z",
    fill: "#BE7C5E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6425 23.435H35.7536C35.6693 22.9934 35.4322 22.5956 35.0838 22.3114C34.7354 22.0272 34.2981 21.8748 33.8485 21.881C33.3795 21.9329 32.9313 22.1025 32.5456 22.3743C32.1598 22.646 31.8491 23.0109 31.6425 23.435V23.435Z",
    fill: "#333333"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5939 24.5376C31.7047 24.5376 31.7946 24.3694 31.7946 24.1619C31.7946 23.9544 31.7047 23.7861 31.5939 23.7861C31.4831 23.7861 31.3933 23.9544 31.3933 24.1619C31.3933 24.3694 31.4831 24.5376 31.5939 24.5376Z",
    fill: "#BE7C5E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8062 24.5376C35.917 24.5376 36.0068 24.3694 36.0068 24.1619C36.0068 23.9544 35.917 23.7861 35.8062 23.7861C35.6954 23.7861 35.6056 23.9544 35.6056 24.1619C35.6056 24.3694 35.6954 24.5376 35.8062 24.5376Z",
    fill: "#BE7C5E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.6425 23.4902H35.7536C35.6693 23.0486 35.4322 22.6507 35.0838 22.3666C34.7354 22.0824 34.2981 21.93 33.8485 21.9362C33.3795 21.988 32.9313 22.1577 32.5456 22.4294C32.1598 22.7012 31.8491 23.0661 31.6425 23.4902Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M52.268 34.8237H28.6809V36.2536H52.268V34.8237Z",
    fill: "#E0E0E0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M52.268 38.397H28.6809V39.8268H52.268V38.397Z",
    fill: "#E0E0E0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2697 23.3872H40.118V24.8171H52.2697V23.3872Z",
    fill: "#E0E0E0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1966 26.9614H41.1893V28.3913H51.1966V26.9614Z",
    fill: "#00BFA6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M49.41 41.9712H28.6809V43.401H49.41V41.9712Z",
    fill: "#E0E0E0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5503 45.5454H28.6809V46.9753H46.5503V45.5454Z",
    fill: "#E0E0E0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4059 49.1196H28.6809V50.5495H44.4059V49.1196Z",
    fill: "#E0E0E0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6946 52.6938H28.6809V54.1237H48.6946V52.6938Z",
    fill: "#E0E0E0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M36.543 56.2671H28.6809V57.6969H36.543V56.2671Z",
    fill: "#00BFA6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2515 56.1033L54.7725 58.4146L58.3442 53.1631L59.6055 54.2139L54.7733 60.5162L51.2024 56.5251L52.2515 56.1033Z",
    fill: "#FFFBF2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7591 53.3407L57.6442 59.0648L54.2629 55.6835L55.5631 54.3833L57.3842 56.2043L61.2856 51.9521L62.7591 53.3407Z",
    fill: "#FFFBF2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11398_14080",
    x1: 105.968,
    y1: 36.7107,
    x2: 60.1425,
    y2: 29.7966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11398_14080",
    x1: 44.0936,
    y1: 48.4917,
    x2: 44.0936,
    y2: 38.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11398_14080",
    x1: 25.4695,
    y1: 26.1596,
    x2: 18.0349,
    y2: -19.7026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11398_14080",
    x1: 19.4921,
    y1: -3.91297,
    x2: 19.4921,
    y2: -13.7705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11398_14080",
    x1: 40.6635,
    y1: 61.1693,
    x2: 40.6635,
    y2: 14.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11398_14080",
    x1: -57.2584,
    y1: 30.5936,
    x2: -57.2584,
    y2: 20.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.102
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activation.1f5e13b6.svg";
export { ForwardRef as ReactComponent };